import React from "react";

export function Pricing() {
  const plans = [
    {
      name: "Free",
      price: "$0",
      description: "Basic access for casual users.",
      features: [
        "Access to dashboard",
        "Basic stats",
        "Limited history"
      ],
      highlighted: false
    },
    {
      name: "Pro",
      price: "$5 / month",
      description: "Perfect for regular players.",
      features: [
        "Full match history",
        "Advanced stats",
        "Priority updates",
        "Custom themes"
      ],
      highlighted: true
    },
    {
      name: "Elite",
      price: "$12 / month",
      description: "For competitive players who want everything.",
      features: [
        "All Pro features",
        "Deep analytics",
        "Performance insights",
        "Early access to new tools"
      ],
      highlighted: false
    }
  ];

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-4xl font-bold mb-2">Pricing</h1>
        <p className="text-muted text-lg">
          Choose the plan that fits your playstyle.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className={`
              p-6 rounded-xl border border-border bg-surface transition-all
              ${plan.highlighted ? "border-[#4FC3F7] shadow-[0_0_20px_rgba(79,195,247,0.2)]" : ""}
            `}
          >
            {plan.highlighted && (
              <div className="text-xs font-bold text-[#4FC3F7] mb-3 uppercase tracking-wide">
                Most Popular
              </div>
            )}

            <h2 className="text-2xl font-bold mb-2">{plan.name}</h2>
            <p className="text-3xl font-bold mb-4">{plan.price}</p>
            <p className="text-muted mb-6">{plan.description}</p>

            <ul className="space-y-2 mb-6">
              {plan.features.map((f) => (
                <li key={f} className="text-sm text-text">
                  • {f}
                </li>
              ))}
            </ul>

            <button
              className={`
                w-full py-2 rounded-md font-semibold transition-all
                ${plan.highlighted
                  ? "bg-[#4FC3F7] text-black hover:bg-[#81D4FA]"
                  : "bg-border hover:bg-border/60"}
              `}
            >
              Choose {plan.name}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}